var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        "before-close": _vm.onBeforeClose,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "show-close": _vm.noticesData.closeable === 1 || _vm.isCanClose,
        title: _vm.noticesData.title || "",
        visible: _vm.isShowNotices,
        width: _vm.getDialogWidth,
        center: "",
        "custom-class": "insureNotices",
        "destroy-on-close": "",
        top: "16vh",
      },
      on: {
        "update:visible": function ($event) {
          _vm.isShowNotices = $event
        },
      },
    },
    [
      [
        _c(
          "el-row",
          {
            staticClass: "center_info_content",
            attrs: { justify: "center", type: "flex" },
          },
          [
            _c("el-col", { attrs: { span: 22 } }, [
              _c("div", [
                _c("span", {
                  domProps: { innerHTML: _vm._s(_vm.noticesData.content) },
                }),
              ]),
              _c(
                "table",
                { staticStyle: { width: "100%" } },
                _vm._l(_vm.noticesData.items, function (itemData, index) {
                  return _c("tr", { key: index }, [
                    _c("td", [
                      _vm.isCheck
                        ? _c(
                            "div",
                            { staticClass: "u-flex" },
                            [
                              _c(
                                "el-checkbox",
                                {
                                  model: {
                                    value: _vm.checkResultData[index],
                                    callback: function ($$v) {
                                      _vm.$set(_vm.checkResultData, index, $$v)
                                    },
                                    expression: "checkResultData[index]",
                                  },
                                },
                                [
                                  _c("span", {
                                    domProps: { innerHTML: _vm._s(itemData) },
                                  }),
                                ]
                              ),
                            ],
                            1
                          )
                        : _c("div", {
                            domProps: { innerHTML: _vm._s(itemData) },
                          }),
                    ]),
                  ])
                }),
                0
              ),
            ]),
          ],
          1
        ),
        _c(
          "div",
          {
            staticStyle: { "margin-top": "20px" },
            attrs: { slot: "footer" },
            slot: "footer",
          },
          [
            _c("div", { staticClass: "footer u-flex-col u-col-center" }, [
              _vm.isHasScroll
                ? _c(
                    "div",
                    {
                      staticClass:
                        "u-m-b-10 u-font-weight-bold footer_hint u-flex u-col-center",
                    },
                    [
                      _c("el-icon", {
                        staticClass:
                          "el-icon-d-arrow-left u-font-weight-bold u-m-r-5",
                      }),
                      _vm._v(
                        "\n\t\t\t\t\t请滑动鼠标至底部，阅读并确认全部内容！\n\t\t\t\t"
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "u-flex u-row-center" },
                [
                  _vm.noticesData.cancelText
                    ? _c(
                        "el-button",
                        {
                          staticStyle: { margin: "0 15px" },
                          on: { click: _vm.onCancel },
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t" +
                              _vm._s(_vm.noticesData.cancelText) +
                              "\n\t\t\t\t\t"
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm.noticesData.confirmText
                    ? _c(
                        "el-button",
                        {
                          staticStyle: { margin: "0 15px" },
                          attrs: {
                            disabled:
                              _vm.currentCount > 0 ||
                              (_vm.isHasScroll && !_vm.isScrollEnd),
                            type: "primary",
                          },
                          on: { click: _vm.onSure },
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t" +
                              _vm._s(_vm.getConfirmText) +
                              "\n\t\t\t\t\t"
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]),
          ]
        ),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }